// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".thread-editor-text-body{display:block}.thread-editor-text-body__title{position:relative}.thread-editor-text-body__title:after{content:\"\";position:absolute;bottom:0;left:15px;right:15px;height:1px;background-color:#c6c6c6}", ""]);
// Exports
module.exports = exports;
